import api from './api'; 

interface Book {
  name: string;
  chapters: string[];
}

interface ChapterResponse {
  subject: string;
  board: string;
  classLevel: string;
  country: string;
  books: Book[];
}

export const getChapters = async (subject: string): Promise<ChapterResponse> => {
  try {
    const response = await api.get('/mock/getChapters', { params: { subject } });
    return response.data;
  } catch (error) {
    console.error('Error fetching chapters:', error);
    throw new Error('Failed to fetch chapters');
  }
};